import React from 'react';

import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Radium, { StyleRoot } from 'radium';
import Img from 'react-image';
import logoIdilio from "./../../assets/images2/brochure/idilioVistania/sketch2.jpg";

import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

import { fadeInRight } from 'react-animations';
import './sass/index.sass';

const styles = {
  fadeInRight: {
    animation: 'x 2.4s',
    animationName: Radium.keyframes(fadeInRight, 'fadeInRight'),
  },
  fadeInRight2: {
    animation: 'x 4.2s',
    animationName: Radium.keyframes(fadeInRight, 'fadeInRight'),
  },
};

class BrochureIdilioVistania extends React.Component<any, any> {
  componentDidMount() {
    const path = window.location.pathname.split('/')[2];
    const pathNameProject = window.location.pathname.split('/').length > 3;
    const project = window.location.pathname.includes('/proyectos');
    const concept = window.location.pathname.includes('/concept');
    const coverProject = document.getElementById('cover');
    const bg = document.getElementById('img-background');
    const app = document.getElementById('app');
    const btn = document.getElementById('btn-iso');
    if (app) {
      app.classList.remove('lumina');
      app.classList.remove('via-maria');
      app.classList.remove('torre-texao');
      app.classList.remove('puerta-del-sol');
      app.classList.remove('ikiga');
      app.classList.remove('idilio-vistania');
      app.classList.add(path);
    }
    if (coverProject && project) {
      coverProject.classList.add(`cover-two`);
    }
    if (bg) {
      bg.classList.remove('lumina-cover');
      bg.classList.remove('via-maria-cover');
      bg.classList.remove('torre-texao-cover');
      bg.classList.remove('puerta-del-sol-cover');
      bg.classList.remove('ikiga-cover');
      bg.classList.remove('idilio-vistania-cover');
      bg.classList.add(`${path}-cover`);
      if (!pathNameProject) {
        bg.classList.remove('blur');
      }
    }
    if (!concept && coverProject) {
      coverProject.classList.remove(`cover-three`);
    }
    if (btn) {
      btn.style.display = 'none';
    }
  }

  render() {
    return (
      <div className="cont-mv">
        <StyleRoot>
          <div className="flex">
            <div className="mission brochure" style={styles.fadeInRight}>
              
              <div className="pdf-container">
                <a
                  href="/files/BrochureIdilioVistania.pdf"
                  download="Brochure Idilio Vistania"
                  target="_blank"
                  className="pdf-link"
                >
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: 'grey' }} size="5x" />

                  <div className="download-call">
                    <span className="arrow">⬆</span>
                    <span>¡DESCARGA AQUÍ!</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="vission imgIdilio" style={styles.fadeInRight2}>
              <Img
                src={logoIdilio}
                loader={
                  <div className="loader">
                    <FontAwesomeIcon icon={faSpinner} pulse />
                  </div>
                }
                alt=""
              />
            </div>
          </div>
        </StyleRoot>
      </div>
    );
  }
}

export default BrochureIdilioVistania;
